import { canDeleteBackward, getListItemsInRange, getListsInRange, getListType, getNestedList, getParentList, getParentListItem, isCursorAtStartOfListItem, isCursorInEmptyListItem, isInList, isListItemContainingText } from "./lib/index.js";
import { decreaseDepth, decreaseListItemDepth, increaseDepth, increaseListItemDepth, mergeListWithPreviousSiblingList, moveListItemsToAnotherList, moveListToListItem, setListType, splitListItem, unwrapList, wrapInList } from "./transformations/index.js";
// Workaround name collision

export var ListsEditor = {
  isListsEditor(editor) {
    return 'isListNode' in editor;
  },
  canDeleteBackward,
  decreaseDepth,
  decreaseListItemDepth,
  getListItemsInRange,
  getListsInRange,
  getListType,
  getNestedList,
  getParentList,
  getParentListItem,
  increaseDepth,
  increaseListItemDepth,
  isCursorAtStartOfListItem,
  isCursorInEmptyListItem,
  isInList,
  isListItemContainingText,
  mergeListWithPreviousSiblingList,
  moveListItemsToAnotherList,
  moveListToListItem,
  setListType,
  splitListItem,
  unwrapList,
  wrapInList
};